// --- 疗养信息 --- //

export default [
  {
    name: 'convalescenceNotice',
    path: '/convalescenceSystem/convalescenceNotice',
    meta: { title: '公告信息' },
    component: require('business/convalescenceSystem/convalescenceNotice/list.vue').default
  },
  {
    name: 'convalescenceNoticeAdd',
    path: '/convalescenceSystem/convalescenceNotice/add',
    meta: { title: '发布公告' },
    component: require('business/convalescenceSystem/convalescenceNotice/add.vue').default
  },
  {
    name: 'convalescenceNoticeDetail',
    path: '/convalescenceSystem/convalescenceNotice/detail',
    meta: { title: '公告信息详情' },
    component: require('business/convalescenceSystem/convalescenceNotice/detail.vue').default
  }

]
